// Cart Auto-Add
  window.addEventListener("abra:cart:changed", () => {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );
  });